"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OceanCompute = exports.ComputeJobStatus = void 0;
var Instantiable_abstract_1 = require("../Instantiable.abstract");
var utils_1 = require("../utils");
exports.ComputeJobStatus = Object.freeze({
    Started: 10,
    ConfiguringVolumes: 20,
    ProvisioningSuccess: 30,
    DataProvisioningFailed: 31,
    AlgorithmProvisioningFailed: 32,
    RunningAlgorithm: 40,
    FilteringResults: 50,
    PublishingResult: 60,
    Completed: 70,
    Stopped: 80,
    Deleted: 90
});
var OceanCompute = (function (_super) {
    __extends(OceanCompute, _super);
    function OceanCompute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OceanCompute.getInstance = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var instance;
            return __generator(this, function (_a) {
                instance = new OceanCompute();
                instance.setInstanceConfig(config);
                return [2, instance];
            });
        });
    };
    OceanCompute.prototype.order = function (consumerAccount, datasetDid, algorithmDid, algorithmMeta, provider) {
        var _this = this;
        return new utils_1.SubscribablePromise(function (observer) { return __awaiter(_this, void 0, void 0, function () {
            var _a, assets, keeper, utils, ddo, service, condition, agreementId;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.ocean, assets = _a.assets, keeper = _a.keeper, utils = _a.utils;
                        return [4, assets.resolve(datasetDid)];
                    case 1:
                        ddo = _b.sent();
                        service = ddo.findServiceByType('compute');
                        if (!service)
                            return [2, null];
                        if (algorithmMeta) {
                            if (service.attributes.main.privacy)
                                if (!service.attributes.main.privacy.allowRawAlgorithm)
                                    return [2, null];
                        }
                        if (algorithmDid) {
                            if (service.attributes.main.privacy)
                                if (service.attributes.main.privacy.trustedAlgorithms)
                                    if (service.attributes.main.privacy.trustedAlgorithms.length > 0)
                                        if (!service.attributes.main.privacy.trustedAlgorithms.includes(algorithmDid))
                                            return [2, null];
                        }
                        condition = keeper.conditions.computeExecutionCondition;
                        return [4, utils.services.order('compute', condition, observer, consumerAccount, ddo, provider)];
                    case 2:
                        agreementId = _b.sent();
                        return [2, agreementId];
                }
            });
        }); });
    };
    OceanCompute.prototype.checkOutput = function (consumerAccount, output) {
        var isDefault = !output || (!output.publishAlgorithmLog && !output.publishOutput);
        if (isDefault) {
            return {
                publishAlgorithmLog: false,
                publishOutput: false
            };
        }
        return {
            publishAlgorithmLog: output.publishAlgorithmLog,
            publishOutput: output.publishOutput,
            brizoAddress: output.brizoAddress || this.config.brizoAddress,
            brizoUri: output.brizoUri || this.config.brizoUri,
            metadataUri: output.metadataUri || this.config.aquariusUri,
            nodeUri: output.nodeUri || this.config.nodeUri,
            owner: output.owner || consumerAccount.getId(),
            secretStoreUri: output.secretStoreUri || this.config.secretStoreUri
        };
    };
    OceanCompute.prototype.start = function (consumerAccount, agreementId, algorithmDid, algorithmMeta, output) {
        return __awaiter(this, void 0, void 0, function () {
            var computeJobsList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        output = this.checkOutput(consumerAccount, output);
                        if (!agreementId) return [3, 2];
                        return [4, this.ocean.brizo.compute('post', agreementId, consumerAccount, algorithmDid, algorithmMeta, undefined, output)];
                    case 1:
                        computeJobsList = _a.sent();
                        return [2, computeJobsList[0]];
                    case 2: return [2, null];
                }
            });
        });
    };
    OceanCompute.prototype.stop = function (consumerAccount, agreementId, jobId) {
        return __awaiter(this, void 0, void 0, function () {
            var computeJobsList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.ocean.brizo.compute('put', agreementId, consumerAccount, undefined, undefined, jobId)];
                    case 1:
                        computeJobsList = _a.sent();
                        return [2, computeJobsList[0]];
                }
            });
        });
    };
    OceanCompute.prototype.delete = function (consumerAccount, agreementId, jobId) {
        return __awaiter(this, void 0, void 0, function () {
            var computeJobsList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.ocean.brizo.compute('delete', agreementId, consumerAccount, undefined, undefined, jobId)];
                    case 1:
                        computeJobsList = _a.sent();
                        return [2, computeJobsList[0]];
                }
            });
        });
    };
    OceanCompute.prototype.restart = function (consumerAccount, agreementId, jobId) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.stop(consumerAccount, agreementId, jobId)];
                    case 1:
                        _a.sent();
                        return [4, this.start(consumerAccount, agreementId, jobId)];
                    case 2:
                        result = _a.sent();
                        return [2, result];
                }
            });
        });
    };
    OceanCompute.prototype.status = function (consumerAccount, agreementId, jobId) {
        return __awaiter(this, void 0, void 0, function () {
            var computeJobsList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.ocean.brizo.compute('get', agreementId, consumerAccount, undefined, undefined, jobId)];
                    case 1:
                        computeJobsList = _a.sent();
                        return [2, computeJobsList];
                }
            });
        });
    };
    OceanCompute.prototype.result = function (consumerAccount, agreementId, jobId) {
        return __awaiter(this, void 0, void 0, function () {
            var computeJobsList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.ocean.brizo.compute('get', agreementId, consumerAccount, undefined, undefined, jobId)];
                    case 1:
                        computeJobsList = _a.sent();
                        return [2, computeJobsList[0]];
                }
            });
        });
    };
    OceanCompute.prototype.createComputeServiceAttributes = function (consumerAccount, price, datePublished, computePrivacy, timeout) {
        return __awaiter(this, void 0, void 0, function () {
            var templates, serviceAgreementTemplate, name, service;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        templates = this.ocean.keeper.templates;
                        return [4, templates.escrowComputeExecutionTemplate.getServiceAgreementTemplate()];
                    case 1:
                        serviceAgreementTemplate = _a.sent();
                        name = 'dataAssetComputingServiceAgreement';
                        if (!timeout)
                            timeout = 3600;
                        service = {
                            type: 'compute',
                            index: 3,
                            serviceEndpoint: this.ocean.brizo.getComputeEndpoint(),
                            templateId: templates.escrowComputeExecutionTemplate.getId(),
                            attributes: {
                                main: {
                                    creator: consumerAccount.getId(),
                                    datePublished: datePublished,
                                    price: price,
                                    privacy: {},
                                    timeout: timeout,
                                    name: name
                                },
                                serviceAgreementTemplate: serviceAgreementTemplate
                            }
                        };
                        if (computePrivacy)
                            service.attributes.main.privacy = computePrivacy;
                        return [2, service];
                }
            });
        });
    };
    return OceanCompute;
}(Instantiable_abstract_1.Instantiable));
exports.OceanCompute = OceanCompute;
//# sourceMappingURL=OceanCompute.js.map